module.exports = __webpack_public_path__ + "img/logo-primary.ca535d94.png";